import styled from "styled-components";

export const EmployerDashboardWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    "& h3": {
      marginBlock: 0,
      fontWeight: 600,
      fontSize: "24px",
    },
    "& .company-streak-card": {
      background: "#FFF",
      boxShadow: "0 8px 24px -4px var(--color-button-secondary)",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-4px)",
      },
      "& .card-title": {
        color: "var(--color-text-light)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        letterSpacing: "1.6px",
        textTransform: "uppercase",
      },
      "& .card-body": {
        paddingTop: "2rem",
      },
      "& .card-body-introduction": {
        padding: "calc(var(--cardPadding)/2) 0",
        p: {
          fontWeight: 700,
          fontSize: "16px",
        },
      },
      "& .card-body-list": {
        paddingInline: 0,
        overflow: "hidden",
        display: "inline-grid",
        margin: 0,
        rowGap: "1rem",
        columnGap: "1rem",
        alignSelf: "stretch",
        gridTemplateRows: "5.75rem",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

        "& li": {
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          padding: "0.72rem",
          paddingTop: "1rem",
          alignItems: "flex-start",
          justifySelf: "stretch",
          backgroundColor: "var(--color-button-secondary)",
          borderRadius: ".5rem",
          color: "var(--color-text-light)",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 600,
          // lineHeight: "16px",
          letterSpacing: "-0.6px",
          textTransform: "uppercase",
          "& span": {
            color: "var(--color-primary)",
            fontSize: "36px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "40px",
          },
        },
      },
      "& p": {
        marginBlock: 0,
      },
    },
    "& .last-payroll-card": {
      background: "#FFF",
      boxShadow: "0 8px 24px -4px var(--color-button-secondary)",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-4px)",
      },
      "& .card-title": {
        color: "var(--color-text-light)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        letterSpacing: "1.6px",
        textTransform: "uppercase",
      },
      "& .card-body": {
        paddingTop: "2rem",
        "& p": {
          color: "#var(--color-text)",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "28px",
          "& span": {
            color: "var(--color-primary)",
            fontSize: "clamp(2.5rem, 5vw, 3.75rem)",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "60px",
          },
        },
      },
      "& .card-body-introduction": {
        padding: "calc(var(--cardPadding)/2) 0",
        p: {
          fontWeight: 700,
          fontSize: "16px",
        },
      },
      "& p": {
        marginBlock: 0,
      },
    },
    "& .wallet-card": {
      background: "#FFF",
      boxShadow: "0 8px 24px -4px var(--color-button-secondary)",
      transition: "transform 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        transform: "translateY(-4px)",
      },
      "& .card-title": {
        color: "var(--color-text-light)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        letterSpacing: "1.6px",
        textTransform: "uppercase",
      },
      "& .card-body": {
        paddingTop: "2rem",
        "& p": {
          color: "var(--color-text)",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "28px",
          "& span": {
            color: "var(--color-primary)",
            fontSize: "clamp(3rem, 5vw, 3.75rem)",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "60px",
          },
        },
      },
      "& .card-body-introduction": {
        padding: "calc(var(--cardPadding)/2) 0",
        p: {
          fontWeight: 700,
          fontSize: "16px",
        },
      },
      "& p": {
        marginBlock: 0,
      },
    },
    "@media screen and (max-width: 1230px)": {
      "& .cards-group": {
        flexDirection: "column",
      },
    },
    "@media screen and (max-width: 768px)": {
      "& .card-table-filter": {
        gap: 0,
        flexDirection: "column",
        overflow: "hidden",
      },
    },
  };
});
